import { Component, ElementRef, Input } from '@angular/core';
import { TotemWidget } from '../totem-widget';
import { TravelDataService } from 'pg-lib/services/travel-data.service';

@Component({
    selector: 'app-totem-widget-checklist',
    templateUrl: './totem-widget-checklist.component.html',
    styleUrls: ['./totem-widget-checklist.component.scss'],
    standalone: false
})
export class TotemWidgetChecklistComponent extends TotemWidget {

    size:'md' = 'md'

    @Input() checkList:Array<{ label: string, description?: string, checked?: boolean, extended?: boolean, key?: string, category?: string }>;
    @Input() editable:boolean;

    @Input() country:string;
    @Input() viaggiareSicuriData:any;

    /** When set, checklist syncs with travel packing API. */
    @Input() travelId:number;
    @Input() useTravelPacking:boolean;

    constructor(public elementRef:ElementRef, private travelDataService:TravelDataService) {
        super(elementRef);
    }

    ngOnInit(): void {
        if(this.useTravelPacking && this.travelDataService.isEnabled()) {
            const fromTravel = this.travelDataService.packingToCheckList();
            if(fromTravel.length) {
                this.checkList = fromTravel;
            }
            if(this.travelId == null) {
                this.travelId = this.travelDataService.currentTravelId;
            }
            return;
        }

        if(this.country != null && this.viaggiareSicuriData != null) {
            this.checkList = [];

            let _requisitiIngresso = this.viaggiareSicuriData.infoRequisitiIngresso?.nodi;
            if(_requisitiIngresso != null) {
                for(let i in _requisitiIngresso) {
                    this.checkList.push({ label: _requisitiIngresso[i].titolo, description: _requisitiIngresso[i].contenuto })
                }
            }
        }

        // Fallback locale when travel API is not used
        let _savedData = localStorage.getItem('DEMOTOTEM-' + this.id);

        if(_savedData != null && this.checkList) {
            let _checkedList:Array<string> = JSON.parse(_savedData)

            for(let _item of this.checkList) {
                _item.checked = _checkedList.indexOf(_item.label) != -1;
            }
        }
    }

    getCheckedCount() {
        let _count = 0;

        for(let _item of this.checkList || []) {
            if(_item.checked) _count++;
        }

        return _count;
    }

    isAllChecked() {
        return this.checkList?.length > 0 && this.getCheckedCount() == this.checkList.length
    }

    shouldShowCategory(index: number) {
        const item = this.checkList?.[index];
        if (!item?.category) return false;
        if (index === 0) return true;
        return this.checkList[index - 1]?.category !== item.category;
    }

    onCheckedChange() {
        if(this.travelDataService.isEnabled() && this.travelId != null && this.checkList?.some(i => i.key)) {
            const items = this.checkList
                .filter((item) => item.key)
                .map((item) => {
                    const parts = item.key.split(':');
                    return {
                        category: item.category || parts[0],
                        item: item.label || parts.slice(1).join(':'),
                        checked: !!item.checked
                    };
                });

            this.travelDataService.updatePackingChecklist(this.travelId, {
                items,
                replace: false
            }).subscribe({
                error: (err) => console.warn('Travel packing checklist save failed', err)
            });
            return;
        }

        let _checkedList = []

        for(let _item of this.checkList || []) {
            if(_item.checked) _checkedList.push(_item.label)
        }

        localStorage.setItem('DEMOTOTEM-' + this.id, JSON.stringify(_checkedList))
    }
}
